import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';

import * as contentActions from '../../../actions/contentActions';
import * as contentUtils from '../../../utils/contentUtils';
import ClassroomActiveCardCommon from './ClassroomActive.card.common';
import CustomIcon from '../../common/CustomIcon';
import BookDownloadBar from '../../book/BookDownloadBar/BookDownloadBar';

class ClassroomActiveCardElectron extends React.Component {
  constructor(props) {
    super(props);

    this.handleSaveClassroom = this.handleSaveClassroom.bind(this);
    this.renderLoadBar = this.renderLoadBar.bind(this);
  }

  static propTypes = {
    id: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    studentsCount: PropTypes.number.isRequired,
    isDragging: PropTypes.bool,
    contentActions: PropTypes.object,
    contentBooks: PropTypes.object,
    key: PropTypes.string,
    image: PropTypes.string,
    classCode: PropTypes.string,
    picture: PropTypes.string,
    asset: PropTypes.string
  };

  handleSaveClassroom = () => {
    const { contentActions, id } = this.props;
    contentActions.saveClassroom(id);
  };

  isDownloading(downloadingBooks) {
    return downloadingBooks && downloadingBooks.length > 0;
  }

  renderLoadBar() {
    const { id } = this.props;

    return <BookDownloadBar classId={id} wrapperClassName={'load-bar-classroom-wrapper'} />;
  }

  getElectronMenuOptions() {
    const { id: classId, contentBooks } = this.props;
    if (!classId || !contentBooks) return;

    const downloadingBooks = contentUtils.getClassroomBooksDownloading(classId, contentBooks);
    const isClassroomContentDownloaded = contentUtils.isClassroomContentDownloaded(classId, contentBooks);
    const isClassroomContentDownloading = this.isDownloading(downloadingBooks);

    let extraMenuOptions;
    if (!isClassroomContentDownloaded && !isClassroomContentDownloading) {
      extraMenuOptions = [
        {
          position: 2,
          option: {
            text: I18n.t('common.option.downloadAll'),
            onClick: this.handleSaveClassroom,
            icon: 'custom-icons-download-tray',
            disabled: false
          }
        }
      ];
    }

    return extraMenuOptions;
  }

  render() {
    let { key, id, name, studentsCount, image, isDragging, classCode, picture, asset, role } = this.props;

    const extraMenuOptions = this.getElectronMenuOptions();

    return (
      <ClassroomActiveCardCommon
        key={key}
        id={id}
        classCode={classCode}
        picture={picture}
        name={name}
        studentsCount={studentsCount}
        asset={asset}
        image={image}
        isDragging={isDragging}
        extraMenuOptions={extraMenuOptions}
        role={role}
        renderLoadBar={this.renderLoadBar}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    contentBooks: state.content.contentBooks
  };
}

function mapDispatchToProps(dispatch) {
  return {
    contentActions: bindActionCreators(contentActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomActiveCardElectron);
